import {
  OnereWithDettaglioDTO,
  PagamentoWithDettaglioDTO,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { TableData } from '@framework/ui';
import { Divider } from 'antd';
import { ColumnsType, TableRowSelection } from 'antd/es/table/interface';
import Paragraph from 'antd/es/typography/Paragraph';
import Title from 'antd/es/typography/Title';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { burdensColumns } from './burdensColumns';

const SubmissionBurdenTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    line-height: ${props => props.theme.lineHeightHeading3};
  }
`;

export interface ISubmissionBurdenCardProps {
  createPaymentRow?: ReactNode;
  rowSelection?: TableRowSelection<OnereWithDettaglioDTO>;
  paymentsColumns: ColumnsType<PagamentoWithDettaglioDTO>;

  burdens: OnereWithDettaglioDTO[];
  payments: PagamentoWithDettaglioDTO[];
}

export function SubmissionBurdenCard(props: ISubmissionBurdenCardProps) {
  const { createPaymentRow, rowSelection, paymentsColumns, burdens, payments } =
    props;
  const { t } = useTranslation();
  // console.log('SubmissionBurdenCard rowSelection', rowSelection);

  return (
    <>
      <SubmissionBurdenTitle level={2}>
        {t('form.oneri-della-domanda', 'Oneri della Domanda')}
      </SubmissionBurdenTitle>
      <Paragraph>
        {t(
          'form.seleziona-gli-oneri',
          'Seleziona gli oneri per procedere al pagamento',
        )}
      </Paragraph>
      <TableData
        size="small"
        rowSelection={rowSelection}
        dataSource={burdens ?? []}
        columns={burdensColumns}
        pagination={false}
      />
      {/* Riga con il button per il pagamento */}
      {createPaymentRow}

      <Divider />
      <SubmissionBurdenTitle level={2}>
        {t('form.elenco-pagamenti', 'Elenco Pagamenti')}
      </SubmissionBurdenTitle>
      <TableData
        size="small"
        dataSource={payments ?? []}
        columns={paymentsColumns}
        pagination={false}
      />
    </>
  );
}
